import Client from '../axiosClient'
const resource = '/optionals';
const resourcePropPartner = '/optionalsByPartner';

const resourceInit = '/optionals_initialize';
// const resourcePropertyInit = '/partner_optionals_initialize';
const resourceUpdateStatus = '/optionals_change_status';
const resourceDelete = '/optionals_delete';
const resourceCountry = '/filter/country'
const optionalPackages = '/optionals_packages'
const resourceDistance = '/optionals_distance'

export default {
  getIncludedPackages(payload){
    return Client.post(`${optionalPackages}`, payload);
  },

  init(tab=0,id=null) {
    let filterParam = 'tabIndex='+tab;
    return Client.get(`${resourceInit}?${filterParam}&id=${id}`);
  },

  initPropPartner(tab=0,id=null) {
    let filterParam = 'tabIndex='+tab;
    return Client.get(`${resourceInit}?${filterParam}&id=${id}`);
  },


  get(payload) {
    if(payload) { 
      // console.log("filterParam",payload);
      let filterParam = `{"lat":"${payload['geoLocation'].lat}","lng":"${payload['geoLocation'].lng}","name":"${payload['geoLocation'].name}"}`;
      let partnerId = payload['partnerId'] != undefined ? payload['partnerId'] : "0";
      let partnerUserId = payload['dashPartnerId'] != undefined ? payload['dashPartnerId'] : "0";
      return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}&geoLocation=${filterParam}&dashPartnerId=${partnerUserId}&partnerId=${partnerId}`);
    }
    return Client.get(`${resource}`);
  },


  getDataWithFilterByPartner (payload) {
    return Client.post(`filter${resourcePropPartner}`, payload);
  },

  getDataWithFilter (payload) {
    return Client.post(`filter${resource}`, payload);
  },
  getDataWithDistance (payload) {
    return Client.post(`${resourceDistance}`, payload);
  },
  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },

  getCountry() {
    return Client.get(`${resourceCountry}`)
  },
  updateStatus(payload) {
    return Client.post(`${resourceUpdateStatus}`, payload);
  },
  delete(payload) {
    return Client.post(`${resourceDelete}`, payload);
  },
  
  /*update(payload, id) {
    return Client.courierAxios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return Client.courierAxios.delete(`${resource}/${id}`)
  },*/

  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/travel/OptionalRepository.js